export type ReasonKind = 'hold' | 'exclude' | 'transfer';

export type ReasonShow = 'pill' | 'list';

export interface ReasonOption {
  readonly key: string;
  readonly label: string;
  readonly show: ReasonShow;
}

export interface SelectedReason {
  readonly key: string;
  readonly label: string;
}

export const REASON_DICTIONARY_NAME: Readonly<Record<ReasonKind, string>> = {
  hold: 'Hold Reasons',
  exclude: 'Exclude Reasons',
  transfer: 'Transfer Reasons'
};
